module.exports = __webpack_public_path__ + "img/icon_ksdgmnslt.56183c23.png";